<template>
  <div class="todos">
    <home-header></home-header>
    <personal-center></personal-center>
    <div class="content page-width" style="padding: 0px">
      <div class="content-right pull-left" style="margin-top: 0px">
        <div class="info">
          <div class="info-title">{{ todoInfo.title }}</div>
          <div class="info-t">
            <div class="info-info">
              <div class="left">
                此项事务为：
                <span style="color: red; margin-right: 12px;">{{ todoInfo.isMustDealLogin == 1 ? '必办项' : '待办项' }}</span>
                截止日期：
                <span style="color: red">{{ todoInfo.endTime }}</span>
              </div>
              <div class="right">
                完成状态：
                <span style="color: red; margin-right: 12px;">{{ todoInfo.isAnswer ? '已完成' : '未完成' }}</span>
                <template v-if="todoInfo.isAnswer">
                  完成日期：
                  <span style="color: red">{{ todoInfo.answerTime || '未完成' }}</span>
                </template>
              </div>
            </div>
            <div class="info-review" v-if="todoInfo.reviewRemark">
              {{ todoInfo.reviewRemark }}
            </div>
          </div>
          <div v-if="todoInfo.isSign !== 1" id="info-content" class="info-content" v-html="todoInfo.content"></div>

          <iframe v-else :src="webviewSrc" style="width: 100%; height: 80vh; margin-top: 16px" frameborder="0"></iframe>
          <iframe v-if="groupName == '问卷调查'" :src="content" style="width: 100%; height: 80vh; margin-top: 16px" frameborder="0"></iframe>

          <div class="info-files" v-if="todoInfo.isSign !== 1 && todoInfo.docList && todoInfo.docList.length > 0">
            <div class="">此文档包含以下附件:</div>
            <div style="margin-top: 16px">
              <a-row class="docList" :gutter="[24, 24]">
                <a-col :span="8" v-for="item in todoInfo.docList" :key="item.id">
                  <div class="filestyle">
                    <div
                      class="defaultcss"
                      :class="{
                        pdfcss: item.docName.includes('pdf'),
                        doccss: item.docName.includes('doc'),
                        xlscss: item.docName.includes('xls'),
                      }"
                    >
                      <span>{{ item.docName }}</span>
                    </div>
                    <div class="downicon" @click="downloadDoc(item.docUrl, item.docName)">
                      <img src="../../assets/images/downicon.png" />
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>

          <div class="info-form">
            <a-form-model ref="visiblesRef" :model="formData" layout="inline" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <div class="info-item" v-for="itemGroup in visiblesFields" :key="itemGroup.group">
                <div class="info-group">{{ itemGroup.group }}</div>
                <a-row>
                  <template v-for="item in itemGroup.list">
                    <a-col :span="24" style="text-align: center;" v-if="item.type == 'tipsCheckbox'">
                      <a-form-model-item v-if="item.show" :prop="item.label" :wrapper-col="{ span: 24 }" :rules="getCheckboxRules(item)" style="width: 100%">
                        <span v-if="item.required" style="color: red; margin-right: 4px;">*</span>
                        <a-checkbox v-model="formData[item.label]">{{ item.title }}</a-checkbox>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="item.type != 'tipsCheckbox'">
                      <a-form-model-item
                        v-if="item.show"
                        :label="item.title"
                        :prop="item.label"
                        :rules="[{ required: item.required, message: `${item.title}不能为空` }]"
                        style="width: 100%"
                      >
                        <!-- 日期选择框 -->
                        <a-date-picker
                          v-if="item.type == 'date'"
                          valueFormat="YYYY-MM-DD"
                          v-model="formData[item.label]"
                          :placeholder="`请选择${item.title}`"
                        />
                        <!-- 数字输入框 -->
                        <a-input-number
                          v-if="item.type == 'number'"
                          v-model="formData[item.label]"
                          :placeholder="`请输入${item.title}`"
                          :min="0"
                          :max="100000"
                        />
                        <!-- 单选框 -->
                        <j-dict-select-tag v-if="item.type == 'radio'" type="radio" v-model="formData[item.label]" :dictCode="item.dictCode" />
                        <!-- 下拉选择 -->
                        <j-dict-select-tag
                          v-if="item.type == 'select'"
                          type="select"
                          v-model="formData[item.label]"
                          :dictCode="item.dictCode"
                          :placeholder="`请选择${item.title}`"
                        />
                        <!-- 下拉多选 -->
                        <j-multi-select-tag
                          v-if="item.type == 'mutiSelect'"
                          type="multi"
                          v-model="formData[item.label]"
                          :dictCode="item.dictCode"
                          :placeholder="`请选择${item.title}`"
                        />
                        <!-- 文本输入框 -->
                        <a-input v-if="item.type == 'text'" v-model.trim="formData[item.label]" :placeholder="`请输入${item.title}`" allowClear />
                        <!-- 多行文本输入框 -->
                        <a-textarea
                          v-if="item.type == 'textarea'"
                          v-model.trim="formData[item.label]"
                          :placeholder="`请输入${item.title}`"
                          showCount
                          :rows="3"
                          :maxlength="200"
                        />
                        <!-- 签章组件 -->
                        <Sign
                          v-if="item.type == 'sign'"
                          :item="item"
                          :docId="todoInfo.id"
                          :showLogSign="true"
                          v-model="formData[item.label]"
                          @change="
                            val => {
                              formData[item.label] = val;
                            }
                          "
                          @ok="handleSignOk"
                        />
                      </a-form-model-item>
                    </a-col>
                  </template>
                </a-row>
              </div>
            </a-form-model>
            <div v-if="todoInfo.configList && todoInfo.configList.length" class="info-item">
              <docUpload
                v-for="item in todoInfo.configList"
                :key="item.id"
                :info="item"
                :ref="item.id"
                @change="onFileChange"
                @remove="onFileRemove"
                @changeDesc="onChangeDesc"
              ></docUpload>
            </div>
            <div class="submitBtns" v-if="groupName !== '问卷调查'">
              <a-button type="primary" class="home" :loading="loading" :disabled="disabled" @click="submit" style="width: 85px;">
                {{ disabled ? `请仔细阅读以上内容（${time}s)` : '提交' }}
              </a-button>
              <a-popconfirm title="确认清空吗?" @confirm="clearAll">
                <a-button type="default" style="width: 85px;">重置</a-button>
              </a-popconfirm>
            </div>
            <div class="submitBtns" v-if="groupName == '问卷调查' && !todoInfo.isAnswer">
              提交后请更新页面，
              <a-button type="default" @click="reset">点击更新</a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header';
import Foot from '@/common/components/Foot';
import PersonalCenter from '@/common/components/PersonalCenter';
import Sign from '@/common/components/sign.vue';
import docUpload from '../documentDetail/components/docListUpload.vue';
import dayjs from 'dayjs';

export default {
  name: 'todos-list',
  components: {
    HomeHeader,
    Foot,
    PersonalCenter,
    Sign,
    docUpload,
  },
  data() {
    return {
      todoInfo: {}, // 待办详情
      visiblesFields: [], // 待办配置字段
      formData: {}, // 待办表单数据
      delFileIds: [], // 删除附件ID
      fileList: [], // 附件列表
      loading: false,
      disabled: true,
      time: 0,
      timer: null,
      groupName: null,
      content: null,
      fmKey: null,
      studentId: null,
    };
  },
  mounted() {
    this.getTodoDetail();

    this.groupName = this.$route.query.groupName;
    this.content = this.$route.query.content;
    this.fmKey = this.$route.query.fmKey;
    this.studentId = this.$route.query.studentId;
  },
  computed: {
    webviewSrc() {
      return `${this.todoInfo.pdfUrl}#scrollbars=0&toolbar=0&statusbar=0`;
    },
  },
  methods: {
    getCheckboxRules(item) {
      if (!item.required) return []; // 非必填无校验
      return [
        {
          validator: (rule, value, callback) => {
            if (value !== true) {
              callback(`请勾选 ${item.title}`);
            } else {
              callback();
            }
          },
          trigger: ['change', 'input'],
        },
      ];
    },
    handleSignOk() {
      if (this.todoInfo.isSign === 1) {
        this.axios.get(`/biz/home/needDeal/pdfUrl?docId=${this.$route.query.id}`).then(res => {
          if (res.code == 200) {
            this.todoInfo.pdfUrl = res.result;
          }
        });
      }
    },

    /**
     * 获取待办事项详情，和用户提交信息
     */
    async getTodoDetail() {
      try {
        const res = await this.axios.get('/biz/home/needDeal/detail', {
          params: { id: this.$route.query.id },
        });
        let visiblesArr = JSON.parse(res.result.visibles || '[]');

        const res2 = await this.axios.get('/biz/home/document/stuBackDocDetail', { params: { id: this.$route.query.id } });
        if (res2.success) {
          const reviewInfo = res2.result || {};
          const fields = {};
          visiblesArr.forEach(item => {
            let value = reviewInfo[item.label] || undefined;
            if (item.type == 'tipsCheckbox') {
              // 转换布尔值
              if (typeof value == 'string') {
                value = value.toLowerCase() == 'true' || value.toLowerCase() == '1';
              } else if (typeof value == 'number') {
                value = value == 1;
              } else {
                value = !!value;
              }
            }
            item.value = value;
            fields[item.label] = item.value;
          });
          this.formData = { ...fields };

          res.result.configList.forEach(item => {
            item.fileList = (reviewInfo.docList || []).filter(ite => ite.configId == item.id);
          });
        }
        // 将处理后的 visibles 重新序列化
        res.result.visibles = JSON.stringify(visiblesArr);
        this.todoInfo = res.result;

        // ========== 手动构建分组 visibles ==========
        const groupSet = new Set(visiblesArr.map(item => item.group));
        const grouped = Array.from(groupSet).map(group => ({
          group: group,
          list: visiblesArr.filter(ite => ite.group === group),
        }));
        this.visiblesFields = grouped;

        if (!this.todoInfo.submitLimit) {
          this.disabled = false;
        } else {
          this.time = this.todoInfo.submitLimit;
          this.disabled = true;
          this.timer = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              this.disabled = false;
              clearInterval(this.timer);
            }
          }, 1000);
        }
        const shadowHost = document.getElementById('info-content');
        if (shadowHost) {
          // 创建shadow Dom节点
          const shadowRoot = shadowHost.attachShadow({ mode: 'open' });
          // 插入html内容
          shadowRoot.innerHTML = this.todoInfo.content;
        } else {
          console.error('Element #shadow-host not found');
        }
      } catch (error) {}
    },
    downloadDoc(url, name) {
      this.axios
        .get(url, { responseType: 'blob' })
        .then(res => {
          console.log(res);
          const url = window.URL.createObjectURL(res);
          const el = document.createElement('a');
          el.setAttribute('href', url);
          el.setAttribute('download', name);
          el.style.display = 'none';
          document.body.appendChild(el);
          el.click();
          document.body.removeChild(el);
        })
        .catch(err => {});
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        id: file.id,
        docName: file.name,
        fileSize: file.size,
        configId,
        remark: file.remark,
      });
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex(item => item.uid === uid);
      this.fileList.splice(index, 1);
      if (id) this.delFileIds.push(id);
    },
    onChangeDesc({ configId, desc }) {
      this.fileList.forEach(item => {
        if (item.configId === configId) {
          item.remark = desc;
        }
      });
    },

    /**
     * 重置表单
     */
    clearAll() {
      this.formData = {};
      this.fileList = [];
      this.delFileIds = [];
      for (const key in this.$refs) {
        if (key !== 'visiblesRef') {
          const ref = this.$refs[key];
          ref[0].clearFiles();
        }
      }
    },
    async reset() {
      let res = await this.axios.post('/biz/home/update/eduDocumentStudentStatus', {
        documentId: this.$route.query.id,
        studentId: this.studentId,
        formKey: this.fmKey,
      });
      if (res.code == 200) {
        this.getTodoDetail();
      }
    },
    submit() {
      if (this.$refs.visiblesRef) {
        this.$refs.visiblesRef.validate(valid => {
          if (valid) {
            this.loading = true;
            let params = {
              id: this.todoInfo.id,
              docList: this.fileList,
              delFileIds: this.delFileIds.join(','),
              docStuInfo: this.formData,
            };
            this.axios
              .post('/biz/home/needDeal/submit', params)
              .then(res => {
                if (res.success) {
                  this.$message.success('提交成功');
                  this.$store.dispatch('getUndoneTodos');
                  setTimeout(() => {
                    this.$router.push('/todos/list');
                  }, 500);
                } else {
                  this.$message.error(res.message);
                }
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.$message.error('表单必填项校验失败');
            return false;
          }
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;
    width:100%;
    overflow: hidden;

  }
}

.content {
  padding: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.info{
    background-color: #fff;
    padding: 16px 48px;
    .info-title{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 16px;
        text-align: center;
    }
    .info-info{
        background-color: #FEFAED;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        position: relative;
        border-bottom: 1px dashed #E9DBAF;
        &::before{
            content: '';
            width: 6px;
            background-color: #E9DBAF;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .info-review{
      background-color: #FEFAED;
      padding: 8px 24px;
      line-height: 1.5;
      position: relative;
      color: #f00;
      &::before{
          content: '';
          width: 6px;
          background-color: #E9DBAF;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
      }
    }
    .info-content{
        margin-top: 16px;
    }
    .info-files{
        margin-top: 16px;
        .docList{
            display:flex;
            flex-wrap:wrap;
            .filestyle{
                border-radius:10px;
                border:#eef1f1 solid 1px;
                padding:20px;
                width:100%;
                height:100%;
                display:inline-block;
                .defaultcss{
                    background:url("../../assets/images/defaulticon.png") no-repeat left center;
                    padding-left: 46px;
                    float: left;
                    height: 30px;
                }
                .pdfcss{
                    background-image: url("../../assets/images/pdficon.png");
                }
                .doccss{
                    background-image:url("../../assets/images/docicon.png");
                }
                .xlscss{
                    background-image:url("../../assets/images/xlsicon.png");
                }
                .downicon{
                    float: right;
                    width: 22px;
                    height: 22px;
                    cursor: pointer;
                }
            }
        }
    }
    .info-form{
      margin-top: 16px;
      background-color: #F7F9F8;
      .info-item{
        padding: 24px 16px;
        border-bottom: 1px dashed #aaa;
        .info-group{
          font-weight: bold;
          margin-bottom: 16px 0;
        }
      }
      /deep/ .ant-form-item{
        display: flex;
        align-items: center;
      }
      /deep/ .ant-form-item-label{
        width: auto !important;
        flex: 0 0 auto;
        white-space: nowrap;
        padding-right: 8px;
      }
      /deep/ .ant-form-item-label > label{
        white-space: nowrap;
      }
      /deep/ .ant-form-item-control-wrapper{
        flex: 1;
        width: auto !important;
        min-width: 0;
        transform: translateY(-2px);
      }
    }
    .submitBtns{
      text-align: center;
      padding: 24px 0;
      .home{

        background: $bgColor;
        color: #fff;
        border: none;
      }
    }
}

.ant-form-item-with-help {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/todos/detail.vue